const fbq = (...args) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args);
  }
};

export const gtmPageView = (location) => {
  if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'page_view',
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }
};

export const pixelPageView = () => fbq('track', 'PageView');

export const pixelViewContent = (product) => fbq('track', 'ViewContent', {
  content_ids: [product._id],
  content_name: product.name,
  content_type: 'product',
  currency: 'INR',
  value: product.price,
});

export const pixelAddToCart = (product, price) => fbq('track', 'AddToCart', {
  content_ids: [product._id],
  content_name: product.name,
  content_type: 'product',
  currency: 'INR',
  value: price,
});

export const pixelPurchase = (items, totalAmount) => fbq('track', 'Purchase', {
  content_ids: items.map(i => i.productId),
  content_type: 'product',
  currency: 'INR',
  value: totalAmount,
  num_items: items.reduce((s, i) => s + i.quantity, 0),
});
